import useMartyContext from 'hooks/useMartyContext';

export const useKratosCheckoutEnabled = () => {
  const { marketplace } = useMartyContext();

  return marketplace.hasKratosCheckout;
};
